import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/#services' },
  { name: 'About', path: '/#about' },
  { name: 'Contact', path: '/#contact' }];


  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const handleNavClick = (e, path) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    if (path.includes('#')) {
      const sectionId = path.split('#')[1];
      
      // If we're not on home page, navigate to home first
      if (location.pathname !== '/') {
        navigate('/');
        // Wait for navigation and DOM update before scrolling
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        // Already on home page, just scroll
        scrollToSection(sectionId);
      }
    } else if (path === '/') {
      // Home button - navigate to root and scroll to top
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      // Other pages
      navigate(path);
    }
  };

  return (
    <header className="dark-header">
      <div className="header-content">
        <Link to="/" className="logo-link">
          <img 
            src="https://customer-assets-wrfwihn1.emergentagent.net/job_exim-solutions-2/artifacts/q64g06lc_HSNL%20Advisory%20Luxury%20Logo.png"
            alt="HSNL Advisory – Strategic Transaction Advisory"
            className="header-logo"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="dark-nav desktop-nav">
          {navLinks.map((link) =>
          <a
            key={link.name}
            href={link.path}
            onClick={(e) => handleNavClick(e, link.path)}
            className={`dark-nav-link ${location.pathname === link.path ? 'active' : ''}`}>

              {link.name}
            </a>
          )}
          <a
            href="#contact"
            onClick={(e) => handleNavClick(e, '#contact')}
            className="btn-primary">

            Get Started
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu">

          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen &&
      <nav className="mobile-nav">
          {navLinks.map((link) =>
        <a
          key={link.name}
          href={link.path}
          onClick={(e) => handleNavClick(e, link.path)}
          className="mobile-nav-link">

              {link.name}
            </a>
        )}
          <a
          href="#contact"
          onClick={(e) => handleNavClick(e, '#contact')}
          className="btn-primary mobile-cta">

            Get Started
          </a>
        </nav>
      }
    </header>);

};